import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useState } from 'react';
import { FiPlay } from "react-icons/fi";
import { ChevronRight, VolumeX, Volume2 } from 'lucide-react';
import { app, db } from '../Admin/Config/Config';
import { collection, deleteDoc, doc, getDoc, getDocs, increment, limit, query, updateDoc, where } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../Auth/UsersContext';
import ClipPayment from './ClipPayment';
import { getFunctions, httpsCallable } from 'firebase/functions';
import LoadingTwo from '../Loading/LoadingTwo';
import { getAuth } from 'firebase/auth';
import { usePaymentSuccess } from '../Payment/PaymentStatusContext';

export default function Clipchart() {
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [savedPlay, setsavedPlay] = useState(null);
  const [loopCount, setLoopCount] = useState(0);
  const [playing, setPlaying] = useState(true);
  const { openPaymentSuccess } = usePaymentSuccess();

  const navigate = useNavigate();
  const { user } = useUser();



  const levels = [
    {
      id: 1,
      name: "All Levels",
      code: "all",
      count: 13,
      icon: <FiPlay className="w-8 h-8" />,
      color: "from-green-500 to-green-400",
    },
    {
      id: 2,
      name: "Beginner",
      code: "beginner",
      count: 5,
      icon: <FiPlay className="w-8 h-8" />,
      color: "from-blue-500 to-blue-400",
    },
    {
      id: 3,
      name: "Intermediate",
      code: "intermediate",
      count: 8,
      icon: <FiPlay className="w-8 h-8" />,
      color: "from-purple-500 to-purple-400",
    },
    {
      id: 4,
      name: "Advanced",
      code: "advanced",
      count: 8,
      icon: <FiPlay className="w-8 h-8" />,
      color: "from-red-500 to-red-400",
    },

  ];
  const [selectedLevel, setSelectedLevel] = useState('All Levels');
  const [videoUrl, setVideoUrl] = useState();
  const [showPlayer, setShowPlayer] = useState(true);
  const [usedIndices, setUsedIndices] = useState([]);
  const [randomVideos, setRandomVideos] = useState([]);

  // ========================== Get Random Videos ========================== //
  const fetchRandomVideos = async () => {
    const ref = collection(db, "jaffers_english_clipchat_videos");
    const q = query(ref, where("status", "==", true), where("random_status", "==", true), limit(20));
    const querySnapshot = await getDocs(q);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    setRandomVideos(data);
    getRandomVideo(data);
  }

  useEffect(() => {
    fetchRandomVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRandomVideo = async (data, nextFlag) => {
    const userSnap = await getDoc(doc(db, "users", getAuth().currentUser.uid));
    const user = userSnap.data();
    if (user?.clip_chat_payment === false && user?.clip_chat_watched < 3) {
      updateDoc(doc(db, "users", getAuth().currentUser.uid), {
        clip_chat_watched: increment(1),
      });
    }
    if (user?.clip_chat_watched >= 3 && user?.clip_chat_payment === false && nextFlag === true) {
      setPaymentOpen(true);
      return;
    } else {
      if (usedIndices.length === data.length) {
        setUsedIndices([]);
      }
      const availableIndices = data
        .map((_, index) => index)
        .filter((index) => !usedIndices.includes(index));
      const randomIndex =
        availableIndices[Math.floor(Math.random() * availableIndices.length)];
      const document = data[randomIndex];
      setVideoUrl(document ?? videoUrl);
      setUsedIndices((prev) => [...prev, randomIndex]);
    }
  };
  const handlenavigate = (level) => {
    navigate(`/viewclip?id=${level}`);
  }


  // ========================== Payment ========================== //
  const [purchaseLoading, setPurchaseLoading] = useState(false);

  const handlePaymentResult = (result) => {
    setPurchaseLoading(true);
    const functions = getFunctions(app, "asia-south1");
    const payload = {
      platform: "web",
      plan_id: result,
      purchase_type: "clip_chat",
    };
    const paymentRequest = httpsCallable(functions, "orderIdTalk");
    paymentRequest({
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVf5kvPJI5bjBGVG5PiiueDXduVAV5p2kMcA&s",
      ...payload,
    }).then((result) => {
      const order = result.data;
      if (order && order !== 404) {
        const options = {
          key: process.env.REACT_APP_RAZOR_KEY,
          amount: order.amount,
          currency: order.currency,
          name: "Jaffer's English",
          description: "Talk Plan",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVf5kvPJI5bjBGVG5PiiueDXduVAV5p2kMcA&s",
          order_id: order.id,
          method: {
            netbanking: true,
            card: true,
            upi: false, // 👈 this disables UPI in the Checkout form
            wallet: true,
          },
          handler: function (response) {
            openPaymentSuccess({
              status: "success",
              orderId: order.id,
              paymentId: response.razorpay_payment_id,
              courseTitle: "Clip chat",
              amount: order.amount / 100,
            });
          },
          prefill: {
            name: user.name,
            email: user.email,
            contact: user.mobile,
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#3399cc",
          },
          modal: {
            ondismiss: function () {
              // setloading(false);
            },
          },
        };

        try {
          const rzp1 = new window.Razorpay(options);
          rzp1.open();
          setPurchaseLoading(true);
          rzp1.on("payment.failed", function (response) {
            openPaymentSuccess({
              status: "failed",
              orderId: order.id,
              paymentId: response.razorpay_payment_id,
              courseTitle: "Clip chat",
              amount: order.amount / 100,
              message: response.error.code,
            });
          });
        } catch (error) {
          setPurchaseLoading(true);
          console.error("Razorpay Error:", error);
          openPaymentSuccess({
            status: "failed",
            orderId: order.id,
            courseTitle: "Clip chat",
            amount: order.amount / 100,
          });
        }
      }
    });
  };
  // ========================== Saved Videos ========================== //
  const getPhrase = async (id) => {
    const docSnap = await getDoc(doc(db, "jaffers_english_phrases", id));
    return { level: docSnap.data().level }
  }
  const [savedVideo, setSavedVideo] = useState(null);
  const fetchSavedVideos = async () => {
    const ref = collection(db, "users", user.uid, "saved_clips");
    const querySnapshot = await getDocs(ref);
    const data = [];
    querySnapshot.forEach(async (doc) => {
      const phrase = await getPhrase(doc.data().phrase_id);
      data.push({ id: doc.id, ...doc.data(), level: phrase.level });
    });
    setSavedVideo(data);
  }
  useEffect(() => {
    if (user?.uid) {
      fetchSavedVideos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const handleDelete = async () => {
    await deleteDoc(doc(db, "users", user.uid, "saved_clips", savedPlay.id));
    setIsVideoModalOpen(false);
    fetchSavedVideos()
    setsavedPlay(null)
  }
  const [showCaption, setshowCaption] = useState(false)
  const [isMuted, setIsMuted] = useState(true);
  const [isMuted2, setIsMuted2] = useState(true);

  useEffect(() => {
    if (isVideoModalOpen) {
      setIsMuted(true)
    }
  }, [isVideoModalOpen]);


  return (
    <div className="px-4 sm:px-6 lg:px-8 py-4 min-h-screen">
      <LoadingTwo toggle={purchaseLoading} />
      {paymentOpen && (
        <ClipPayment
          toogle={paymentOpen}
          onResult={handlePaymentResult}
          onClose={() => setPaymentOpen(false)}
        />
      )}
      <h2 className="text-3xl font-[inter] font-bold text-emerald-700 mb-4">
        Random Clips
      </h2>
      <div className="mb-6 p-2 border rounded-2xl border-gray-800">
        <div className="aspect-video bg-gray-800 rounded-xl lg:rounded-2xl overflow-hidden relative">
          <ReactPlayer
            url={
              videoUrl?.video_type === "youtube"
                ? "https://www.youtube.com/watch?v=" + videoUrl.video_url
                : videoUrl?.video_url ?? ""
            }
            muted={isMuted}
            width="100%"
            loop={true}
            controls={false}
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
            config={{
              youtube: {
                playerVars: {
                  controls: 0,
                  fs: 0,
                  modestbranding: 1,
                  rel: 0,
                },
              },
              file: {
                attributes: {
                  controlsList: "nofullscreen",
                },
              },
            }}
            playing={playing}
            onPlay={() => {
              setLoopCount(loopCount + 1);
              if (loopCount > 10) {
                setPlaying(false);
              }
            }}
            onClickPreview={() => setShowPlayer(true)}
          />

          {showCaption && (
            <div className="absolute top-12 left-4 z-20 max-w-lg">
              <div className="flex items-start gap-3">
                <div className="relative bg-white  p-8 rounded-tr-2xl rounded-tl-2xl rounded-br-2xl  max-w-xl">
                  <div className="absolute -left-[7px] top-0 w-[7px] h-[7px] overflow-hidden">
                    <div className="absolute -right-[10px] top-0 w-[10px] h-[10px] bg-white/90 backdrop-blur-sm transform rotate-45 origin-bottom-left"></div>
                  </div>
                  <p className="text-violet-700 text-xl">
                    {videoUrl?.meaning ?? ""}
                  </p>
                </div>
              </div>
            </div>
          )}

          <button
            onClick={() => setIsMuted(!isMuted)}
            className="absolute top-4 right-4 z-20 p-2 bg-white backdrop-blur-sm rounded-full"
            aria-label={isMuted ? "Unmute" : "Mute"}
          >
            {isMuted ? (
              <VolumeX className="w-5 h-5 text-black" />
            ) : (
              <Volume2 className="w-5 h-5 text-black" />
            )}
          </button>
          {showPlayer && (
            <div className="absolute bottom-12 sm:bottom-24 left-0 right-0 z-20 flex items-center justify-between px-2 sm:px-4">
              <div
                onClick={() => setshowCaption(!showCaption)}
                className="flex items-center gap-1 sm:gap-2 backdrop-blur-sm rounded-lg cursor-pointer"
              >
                <button className="flex items-center gap-1.5 sm:gap-2.5 bg-gradient-to-br from-emerald-400 to-emerald-600 hover:from-emerald-300 hover:to-emerald-500 text-white px-3 sm:px-4 py-1.5 sm:py-2.5 rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium transition-all duration-300 active:scale-[0.97] shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30 group border border-white/10 backdrop-blur-sm">
                  <span className="truncate max-w-[80px] sm:max-w-none">
                    {videoUrl?.phrase ?? "Video Name"}
                  </span>

                  <span className="h-4 sm:h-5 w-[1px] bg-gradient-to-t from-transparent via-white/50 to-transparent"></span>

                  <span className="flex items-center gap-1 sm:gap-1.5">
                    <span className="relative text-xs sm:text-sm">
                      Show Meaning
                      <span className="absolute left-0 -bottom-0.5 h-[1px] sm:h-[1.5px] w-0 group-hover:w-full bg-white transition-all duration-300"></span>
                    </span>

                    <svg
                      className="ml-1 w-3 h-3 md:w-4 md:h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
                      />
                    </svg>
                  </span>
                </button>
              </div>

              <button
                onClick={() => getRandomVideo(randomVideos, true)}
                className="flex items-center gap-1 sm:gap-2 p-1.5 sm:p-2 bg-emerald-700/90 rounded-md sm:rounded-lg backdrop-blur-sm px-3 sm:px-4 transition-all hover:bg-emerald-600/90"
              >
                <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                <span className="text-xs sm:text-sm text-white font-medium">
                  Next Clip
                </span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="mb-4">
        <h2 className="text-3xl font-[inter] font-bold text-emerald-700 mb-6">
          Explore Levels
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {levels.map((level) => (
            <div
              key={level.id}
              onClick={() => {
                handlenavigate(level.code);
                setSelectedLevel(level.name);
              }}
              className={`relative cursor-pointer rounded-2xl p-6 transition-all duration-300 transform hover:scale-[1.02] 
          ${selectedLevel === level.name
                  ? "ring-2 ring-white/20 shadow-2xl"
                  : "shadow-lg hover:shadow-xl"
                } bg-gradient-to-br from-emerald-700 to-emerald-800`}
            >
              <div className="absolute inset-0 rounded-2xl border-2 border-white/5"></div>

              <div className="flex items-center justify-between">
                <div className="bg-white/10 p-3 rounded-xl backdrop-blur-sm border border-white/10">
                  {React.cloneElement(level.icon, {
                    className: "w-8 h-8 text-white/90",
                  })}
                </div>
              </div>

              <h3 className="text-2xl font-semibold text-white mt-4 mb-2">
                {level.name}
              </h3>
              {/* <p className="text-white/80 font-light tracking-wide">
                Professional Curriculum
              </p> */}

              <div className="mt-4 h-[2px] bg-white/10 rounded-full">
                <div className="h-full bg-white/30 rounded-full w-3/4"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12">
        {savedVideo && savedVideo.length > 0 ? (
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl font-[inter] font-bold text-emerald-700 ">
              Saved Videos
            </h2>
            {/* <button className="text-emerald-600  font-medium flex items-center text-lg">
              View All
            </button> */}
          </div>
        ) : null}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ">
          {savedVideo &&
            savedVideo.map((video) => {
              const color =
                video.level === "beginner"
                  ? "yellow"
                  : video.level === "intermediate"
                    ? "blue"
                    : "green";
              return (
                <div
                  key={video.id}
                  onClick={() => {
                    setsavedPlay(video);
                    setIsVideoModalOpen(true);
                  }}
                  className="group bg-emerald-900/20 hover:bg-emerald-900/30 rounded-2xl p-4 hover:shadow-lg transition-all duration-300 cursor-pointer border border-emerald-400/20 relative"
                >
                  <div className={`absolute -top-3 -left-3 z-10 w-8 h-8 flex items-center justify-center text-emerald-100 rounded-full shadow-lg border-2 ${color === "yellow" ? "border-yellow-600 bg-yellow-600" : color === "blue" ? "border-blue-600 bg-blue-600" : "border-green-600 bg-green-600"}`}>
                    {parseInt(video?.order) - 100000}
                  </div>

                  <h3 className="text-md font-medium text-emerald-100 truncate pl-5">
                    {video.phrase}
                  </h3>
                </div>
              )
            })}
        </div>
      </div>
      {isVideoModalOpen && (
        <div
          className="fixed inset-0 bg-black backdrop-blur-sm md:backdrop-blur-2xl flex items-center justify-center z-50 p-2 md:p-0"
          onClick={() => {
            setsavedPlay(null);
            setIsVideoModalOpen(false);
          }}
        >
          <div
            className="relative w-full h-full max-w-3xl max-h-[90vh] md:max-h-[80vh] rounded-xl md:rounded-2xl overflow-hidden border border-emerald-400/30 shadow-lg md:shadow-2xl shadow-emerald-900/50"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Section */}
            <div className="absolute bottom-0 left-0 right-0 z-40 flex flex-col-reverse md:flex-row justify-between items-center p-3 md:p-5 bg-gradient-to-t from-emerald-900/30 to-transparent gap-2 md:gap-0">
              <div
                onClick={() => setshowCaption(!showCaption)}
                className="text-emerald-200 text-sm font-medium border-emerald-400/40 backdrop-blur-sm cursor-pointer w-full md:w-auto"
              >
                <button className="flex items-center justify-center md:justify-start gap-2.5 bg-gradient-to-br from-emerald-400 to-emerald-600 hover:from-emerald-300 hover:to-emerald-500 text-white px-4 py-2 rounded-lg md:rounded-xl text-sm font-medium transition-all duration-300 active:scale-[0.97] shadow-md md:shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30 group border border-white/10 backdrop-blur-sm w-full md:w-auto">
                  {savedPlay?.phrase ?? ""}

                  <span className="h-5 w-[1px] bg-gradient-to-t from-transparent via-white/50 to-transparent hidden md:block"></span>

                  <span className="flex items-center gap-1.5">
                    <span className="relative">
                      Show Meaning
                      <span className="absolute left-0 -bottom-0.5 h-[1.5px] w-0 group-hover:w-full bg-white transition-all duration-300"></span>
                    </span>

                    <svg
                      className="ml-1 w-2 h-2 md:w-4 md:h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
                      />
                    </svg>
                  </span>
                </button>
              </div>

              {/* Close Button */}
              <div className="flex items-center justify-between w-full md:w-auto gap-2">
                <button
                  onClick={() => setIsMuted2(!isMuted2)}
                  className="p-1.5 md:p-2 bg-white/80 hover:bg-white backdrop-blur-sm rounded-full transition-all duration-300 hover:scale-105"
                  aria-label={isMuted2 ? "Unmute" : "Mute"}
                >
                  {isMuted2 ? (
                    <VolumeX className="w-4 h-4 md:w-5 md:h-5 text-black" />
                  ) : (
                    <Volume2 className="w-4 h-4 md:w-5 md:h-5 text-black" />
                  )}
                </button>
                <button
                  onClick={() => handleDelete()}
                  className="flex items-center space-x-1 md:space-x-2 text-emerald-100 hover:text-white px-3 py-1.5 md:px-4 md:py-2 bg-emerald-600/70 hover:bg-emerald-400/30 rounded-full border border-emerald-400/30 transition-all duration-300 hover:scale-105 text-sm"
                >
                  <svg
                    className="w-4 h-4 md:w-5 md:h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                    />
                  </svg>
                  <span className="text-xs md:text-sm font-medium">
                    Remove clip
                  </span>
                </button>
              </div>
            </div>

            <div className="absolute top-2 right-2 z-40 flex">
              <button
                className="p-1.5 md:p-2.5 text-emerald-200 hover:text-white hover:bg-emerald-400/20 bg-emerald-900/20 rounded-full border border-emerald-400/30 transition-all duration-300 hover:scale-110"
                onClick={() => setIsVideoModalOpen(false)}
              >
                <svg
                  className="w-5 h-5 md:w-7 md:h-7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="relative w-full h-full bg-emerald-900/10">
              <ReactPlayer
                key={savedPlay?.id ?? ""}
                url={
                  savedPlay?.video_type === "youtube"
                    ? "https://www.youtube.com/watch?v=" + savedPlay?.video_url
                    : savedPlay?.video_url ?? ""
                }
                controls
                muted={isMuted2}
                playing
                width="100%"
                height="100%"
                className="react-player rounded-lg md:rounded-xl"
                config={{
                  youtube: {
                    playerVars: {
                      controls: 0,
                      fs: 0,
                      modestbranding: 1,
                      rel: 0,
                    },
                  },
                  file: {
                    attributes: {
                      controlsList: "nofullscreen",
                    },
                  },
                }}
                playIcon={
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-emerald-400/80 rounded-full flex items-center justify-center backdrop-blur-sm">
                    <svg
                      className="w-6 h-6 md:w-8 md:h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                      />
                    </svg>
                  </div>
                }
              />
            </div>
            {showCaption && (
              <div className="absolute top-12 md:top-16 left-2 md:left-4 z-20 max-w-xs md:max-w-lg">
                <div className="flex items-start gap-3">
                  <div className="relative bg-white p-4 md:p-8 rounded-tr-xl rounded-tl-xl rounded-br-xl md:rounded-tr-2xl md:rounded-tl-2xl md:rounded-br-2xl max-w-xs md:max-w-xl">
                    <div className="absolute -left-[7px] top-0 w-[7px] h-[7px] overflow-hidden">
                      <div className="absolute -right-[10px] top-0 w-[10px] h-[10px] bg-white/90 backdrop-blur-sm transform rotate-45 origin-bottom-left"></div>
                    </div>
                    <p className="text-violet-700 text-sm md:text-xl">
                      {savedPlay?.meaning}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="absolute bottom-0 left-0 right-0 z-40 flex justify-between items-center p-5 bg-gradient-to-t from-emerald-900/30 to-transparent"></div>
          </div>
        </div>
      )}
    </div>
  );
}